module.exports = __webpack_public_path__ + "static/media/honeymoon-256.506ceadd.png";